/**
 * Shared enumeration of marketing template categories used by both the
 * admin editor and the storefront shopper filter. Adding a new
 * category here automatically makes it available in both surfaces —
 * one source of truth so the two never drift.
 */
export const MARKETING_CATEGORIES = [
  { value: 'business_card', label: 'Business Cards' },
  { value: 'brochure', label: 'Brochures' },
  { value: 'flyer', label: 'Flyers' },
  { value: 'banner', label: 'Banners' },
  { value: 'social_media', label: 'Social Media' },
  { value: 'postcard', label: 'Postcards' },
  { value: 'email_signature', label: 'Email Signatures' },
  { value: 'door_hanger', label: 'Door Hangers' },
  { value: 'other', label: 'Other' },
];

export const CATEGORY_LABEL_BY_VALUE = Object.fromEntries(
  MARKETING_CATEGORIES.map((c) => [c.value, c.label]),
);
